// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FmP3","toggle":"styles_toggle__2Oza5","preview":"styles_preview__OEoRW"};